import { createContext, useContext, type ReactNode } from 'react';
import { defaultLocale, type Locale } from '@shared/locales';

/**
 * The locale encoded in the URL (unprefixed English, `/{locale}/…` otherwise).
 * Native form fields follow the path: a prefixed URL is that language, and an
 * unprefixed URL is English until a redirect sends the visitor to the
 * language their browser asked for.
 */
const UrlLocaleContext = createContext<Locale>(defaultLocale);

export function UrlLocaleProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return <UrlLocaleContext.Provider value={locale}>{children}</UrlLocaleContext.Provider>;
}

export function useUrlLocale(): Locale {
  return useContext(UrlLocaleContext);
}
